import React from 'react'

import css from './style.scss'

const GenericHtml = (props) => {
  const { html, textColor, linkColor } = props

  if (!html) return null

  // React 15's style-prop diffing doesn't support CSS custom properties
  // (`--foo` keys get dropped), so set them on the DOM node directly.
  const setThemeColors = (node) => {
    if (!node) return
    if (textColor) node.style.setProperty('--genericHtmlHeadingColor', textColor)
    if (linkColor) node.style.setProperty('--genericHtmlLinkColor', linkColor)
  }

  return (
    <div ref={setThemeColors} className={css.genericHtml} dangerouslySetInnerHTML={{ __html: html }} />
  )
}

GenericHtml.propTypes = {
  html: React.PropTypes.string,
  textColor: React.PropTypes.string,
  linkColor: React.PropTypes.string
}

export default GenericHtml
